import { ActionType, getType } from 'typesafe-actions'
import { setCalculations } from 'actions/calculationResults/actions'
import { ICalculationResults } from 'types/ICalculationResults'

const reducer = (
  state: ICalculationResults = {
    matrix: [[]],
    overallAmountOfAnswers: 0,
    filteredAmountOfAnswers: 0,
    maxBinAmount: 0
  },
  action: ActionType<typeof setCalculations>
) => {
  if (action.type === getType(setCalculations)) {
    return action.payload
  }

  return state
}

export { reducer as calculationResults }
